import Start from "../../../views/start"
import { PreviewNode } from "../../../views/nodes/preview-node"
import End from "../../../views/nodes/end"
import { renderNode } from "./render-nodes"
import { Layout } from "../../graph"

const buildNode = (roots, nodeData) => {
  switch (nodeData.kind) {
    case "end":
      return new End(nodeData)
    case "start":
      return new Start(nodeData)
    default:
      return new PreviewNode(roots, nodeData)
  }
}

const createPreviewNode = (nodeData, data) => {
  const node = buildNode(data.roots, nodeData)

  data.scope.appendChild(node)

  return node
}

export const renderPreviewNodes = data => {
  const nodes = data.nodes.map(node => {
    if (data.new_template_preview)
      return renderNode(node, data, createPreviewNode)

    const element = createPreviewNode(node, data)

    return {
      width: node.kind == "end" ? 150 : 240, // Fixing width to preview end/node width
      height: node.kind == "end" ? 50 : 80, // Fixing height to preview end/node height
      element: element,
      source_nodes: node.sources.map(id => data.nodes.find(n => n.id == id)),
      ...node
    }
  })

  // Ensure the graph is laid out with enough vertical space for the explanations
  let { layout } = data
  if (data.new_template_preview) {
    const maxHeight = Math.max(...nodes.map(node => node.height))
    const rankSeparation = Math.max(
      maxHeight + Layout.minNodeHeight,
      Layout.graphConfig.ranksep
    )

    if (rankSeparation > Layout.graphConfig.ranksep) {
      layout.ranksep = rankSeparation
      // The rank/row separation padding is added to the first rank as well, so account for that
      const topAdjustment = (maxHeight - Layout.minNodeHeight) / 2
      data.scope.style.top = `-${topAdjustment}px`
    }
  }

  return {
    ...data,
    layout,
    nodes
  }
}
